import { useQuery } from '@tanstack/react-query';

import { marketingKeys } from '@/hooks/league/marketingKeys';
import { getHpMarketingInfoController } from '@/interface-adapters/controllers/leagues/get-hp-marketing-info.controller';

export const useMarketingInfoQuery = (hpMarketingType: string) => {
	return useQuery({
		queryKey: marketingKeys.marketingInfo(hpMarketingType),
		queryFn: () => getHpMarketingInfoController(hpMarketingType)
	});
};
